import {
	GET_INSURANCE_COMPANIES_BUCKET,
	GET_INSURANCE_COMPANIES_BUCKET_SUCCESS,
	GET_INSURANCE_COMPANIES_BUCKET_FAIL,
	GET_INSURANCE_COMPANIES_BUCKET_RESET,
} from '../actions/getInsuranceCompaniesBucketAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getInsuranceCompaniesBucketReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_INSURANCE_COMPANIES_BUCKET:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_INSURANCE_COMPANIES_BUCKET_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_INSURANCE_COMPANIES_BUCKET_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_INSURANCE_COMPANIES_BUCKET_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getInsuranceCompaniesBucketReducer;
